var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Fragment',[_vm._t("default",null,{"title":_vm.title,"content":_vm.content,"links":_vm.links})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }